import React, { useId } from 'react';
import { LOGO_H, LOGO_W, LogoMaskDefs } from './LogoMaskDefs';
import { siteConfig } from '../../data/siteConfig';
interface LogoMarkFlatProps {
  className?: string;
}

/** Clean, flat logo mark for small sizes where 3D depth would hurt legibility. */
export function LogoMarkFlat({
  className = ''
}: LogoMarkFlatProps) {
  const id = 'qf' + useId().replace(/[^a-zA-Z0-9]/g, '');
  return <span className={`relative block ${className}`} aria-hidden="true" data-id="element-180" data-mp="3tgbt2vaogw8">
      <LogoMaskDefs id={id} data-id="element-181" data-mp="8rrk395xyjcc" />
      <svg viewBox={`0 0 ${LOGO_W} ${LOGO_H}`} className="h-full w-full" data-id="element-182" data-mp="8qpzacz4iihf">
        <image href={siteConfig.logoUrl} width={LOGO_W} height={LOGO_H} preserveAspectRatio="xMidYMid meet" mask={`url(#${id}-mask)`} data-id="element-183" data-mp="diq86ux68lq5" />
      </svg>
    </span>;
}